import React from 'react';
import {} from '@material-ui/core/styles';
import {
  List,
  ListItem,
  ListItemText,
  DialogTitle,
  Dialog,
} from '@material-ui/core';

export default function ClassificationDialog({ onClose, open }) {
  const { tripClassifications } = window.config;

  function handleClose() {
    onClose(null);
  }

  const handleListItemClick = (value) => () => {
    onClose(value);
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="classification-dialog-title"
      open={open}
    >
      <DialogTitle id="classification-dialog-title">
        Select classification
      </DialogTitle>
      <List>
        {tripClassifications.map((classification) => (
          <ListItem
            button
            onClick={handleListItemClick(classification.value)}
            key={classification.value}
          >
            <ListItemText primary={classification.label} />
          </ListItem>
        ))}
      </List>
    </Dialog>
  );
}
